import VueGoogleMaps from '@fawmi/vue-google-maps'

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.use(VueGoogleMaps)
})
